/***
 *
 *   HEADER
 *   Header section with title and children.
 *
 *   DOCS
 *   https://docs.useMapMetrics Atlas.app/MapMetrics Atlas-web/components/header
 *
 *   PROPS
 *   children: children to render (component(s), optional)
 *   title: title of the view (string, optional)
 *
 **********/

export function Header({ title, children }) {
  return (
    <header className="sticky top-0 z-30 p-4 sm:py-6 sm:pl-12 sm:pr-8 mb-8 flex justify-between items-center glass-header dark:glass-header-dark backdrop-blur-lg -mx-3 lg:-mx-4 xl:-mx-6 2xl:-mx-8">
      {title && (
        <h1 className="flex-grow text-white text-2xl sm:text-3xl font-light tracking-wide text-center sm:text-left fade-in poppins-light">
          {title}
        </h1>
      )}

      <div className="slide-up" style={{animationDelay: '0.1s'}}>
        {children}
      </div>
    </header>
  );
}
